import { FC, Fragment, useEffect, useState } from 'react';
import { useAppDispatch, useAppSelector } from '../../../hooks';
import { Helmet } from 'react-helmet-async';
import PageTitleWrapper from '../../../components/PageTitleWrapper';
import AllSitesLedgerHeader from './PageHeader';
import PageContainerWrapper from '../../../components/PageContainerWrapper';
import { Table, TableBody, TableCell, TableHead, TableRow, Typography, Paper, Tooltip, Link } from '@mui/material';
import { currencyFormatter } from '../../../utils';
import { tableStyles } from '../Reports';


export interface AllSitesLedgerProps {}

export const AllSitesLedger: FC<AllSitesLedgerProps> = ({}) => {
  const classes = tableStyles();
  const [checked, setChecked] = useState(true);
  const { data: siteReportRows } = useAppSelector(
    (state) => state.allSitesLedgerState
  );

  let lastSiteNo = '';
  let count = 0;
  return (
    <>
      <Helmet>
        <title>Billing Summary</title>
      </Helmet>
      <PageTitleWrapper>
        <AllSitesLedgerHeader onChecked={setChecked} />
      </PageTitleWrapper>
      <PageContainerWrapper>
        <Table aria-label="billing summary">
          <TableHead>
            <TableRow>
              <TableCell width={20}>S.N.</TableCell> {/* Serial Number column */}
              <TableCell className={classes.tableCell} sx={{maxWidth:200}}>Party Name</TableCell>
              <TableCell className={classes.tableCell} sx={{maxWidth:200}}>Site</TableCell>
              <TableCell className={classes.tableCell}>Site ID</TableCell>
              <TableCell className={classes.tableCell}>Month</TableCell>
              <TableCell className={classes.tableCell}>Billing</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {siteReportRows &&
              siteReportRows.map((bill, index) => {
                const isNewGroup = bill.monthIndex != 100 && bill.siteNo !== lastSiteNo;
                const isNotSum = !(bill.monthIndex == 100 || bill.monthIndex == 1000)
                if(isNotSum) {
                  lastSiteNo = bill.siteNo;
                }

                return (
                  <Fragment key={index}>
                    {/* {isNewGroup && (
                      // Insert a green blank row when siteNo changes
                      <TableRow sx={{backgroundColor:'#efeff0'}}>
                        <TableCell colSpan={6}></TableCell>
                      </TableRow>
                    )} */}
                    {(checked || isNotSum) && (
                    <TableRow>
                      <TableCell >{ isNotSum? ++count : ''}</TableCell> {/* Increment serial number */}
                     
                      <TableCell sx={{maxWidth:200}} colSpan={isNotSum ? 0 : 4} className={classes.tableCell}><Typography variant={isNotSum ? 'body1' : 'h5'}>{bill.party}</Typography></TableCell>
                      {isNotSum && (<>
                        <TableCell sx={{maxWidth:200}} className={classes.tableCell}>{bill.siteAddress}</TableCell>

                          <TableCell className={classes.tableCell}>
                            <Tooltip arrow title="Go to site details">
                              <Link
                               color={'#0000ff'}
                                underline="always"
                                href={`/slips/view-slips/${bill.siteNo}/${bill.partyId}?tab_index=5`}
                              >
                                {isNotSum ? bill.siteNo : ''}
                              </Link>
                            </Tooltip>


                          </TableCell>
                      <TableCell className={classes.tableCell}>{bill.month}</TableCell>
                      </>)}
                      <TableCell className={classes.tableCell}><Typography variant={isNotSum ? 'body1' : 'h5'}>{currencyFormatter.format(bill.invoiceSum)}</Typography></TableCell>
                     
                      </TableRow>
                    )}
                  </Fragment>
                );
              })}
          </TableBody>
        </Table>
      </PageContainerWrapper>
    </>
  );
};

export default AllSitesLedger;
